module.exports = __webpack_public_path__ + "static/media/ring_app.5cf23215.jpg";